import { AxiosInstance, AxiosPromise } from 'axios';
import {
  FileServicesEndpoints,
  FileCreateRequest,
  CreateFileResponse,
  FileDeleteRequest,
  FileDeleteResponse,
} from './FileServices.types';

export class FileServices implements FileServicesEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  create(request: FileCreateRequest) {
    return this.instance.post<CreateFileResponse>('/files', request.body, {
      params: request.queryParams,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  search(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  delete(request: FileDeleteRequest) {
    return this.instance.delete<FileDeleteResponse>(`/files/${request.routeParams.id}`);
  }

  getById(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  update(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }
}
